module.exports = __webpack_public_path__ + "img/krait-hexa-scales.33cc366b.jpg";